/* Panning specific styles */
.panning-wrapper {
  width: calc(100vw - (100vw - 100%));
  overflow-x: auto;
  -webkit-overflow-scrolling: touch; /* important for iOS */
}

.scroll-snap-type {
  /* Safari */
  scroll-snap-type: x mandatory; /* Safari */
  scroll-snap-destination: 50% 50%;
}

.scroll-snap {
  scroll-snap-align: center; /* older (Firefox/IE) */ /* older (Safari) */
  scroll-snap-coordinate: 50% 50%; /* older (Safari) */
  scroll-snap-stop: normal;
}

/* End of: Panning specific styles */

.comparison-section-wrapper {
  padding-bottom: $space-07;

  &.panning-wrapper {
    background-color: $c-neutral-07;
  }

  @include agl-ds-screen-size('medium') {
    padding-bottom: $space-11;
  }

  @include agl-ds-screen-size('large') {
    padding-bottom: $space-14;
  }
}

/* stylelint-disable-next-line selector-class-pattern */
.trim-space {
  padding-bottom: $space-00 !important;
}

/* stylelint-disable-next-line selector-class-pattern */
.guided-flow__product-heading {
  font-size: 2rem;
  display: flex;
  justify-content: center;
  padding-top: $space-07;
  padding-bottom: $space-01;
}

.guided-flow-nbn-heading {
  text-align: center;
  margin-top: $space-07;
}

strong {
  --font-weights-bold: 700;
}
